'use strict';

define('lib/helpers/removePeriods',['Handlebars'], function (Handlebars) {
  Handlebars.registerHelper('removePeriods', function (text) {
    text = Handlebars.Utils.escapeExpression(text);
    text = text.split('.').join('-');
    return new Handlebars.SafeString(text);
  });
});

